import { useEffect, useState } from "react";
import BookPageFlip from "../ui/BookPageFlip";

export default function NotebookViewer({ pages, hintStorageKey }) {
  const [showHint, setShowHint] = useState(() => {
    return sessionStorage.getItem(hintStorageKey) !== "1";
  });

  const [grabbing, setGrabbing] = useState(false);

  useEffect(() => {
    if (!showHint) return;
    const t = setTimeout(() => setShowHint(false), 4500);
    return () => clearTimeout(t);
  }, [showHint]);

  const dismissHint = () => {
    if (!showHint) return;
    sessionStorage.setItem(hintStorageKey, "1");
    setShowHint(false);
  };

  return (
    <div
      className={[
        "relative select-none",
        grabbing ? "cursor-grabbing" : "cursor-grab",
        "[&_*]:cursor-grab",
      ].join(" ")}
      onPointerDown={() => {
        setGrabbing(true);
        dismissHint();
      }}
      onPointerUp={() => setGrabbing(false)}
      onPointerCancel={() => setGrabbing(false)}
      onMouseLeave={() => setGrabbing(false)}
    >
      <BookPageFlip pages={pages} />

      {/* Indicateurs visuels */}
      <div className="pointer-events-none absolute inset-0">
        {/* Fade bords */}
        <div className="absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-black/30 to-transparent" />
        <div className="absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-black/30 to-transparent" />
        {/* Microcopy */}
        {showHint && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full border border-white/15 bg-black/50 px-3 py-1 text-[11px] text-white/85">
            Tourner la page : glissez ou cliquez sur les pages
          </div>
        )}
      </div>
    </div>
  );
}
